import { Accordion } from "flowbite-react"
  const LaravelFAQ: React.FC = () => { return (
        <>
          <Accordion>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">Why is Moweb the ideal choice for my Laravel development projects?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  If you are looking for the best and most affordable Laravel developers, then get in touch with Moweb, a reputable Laravel development services provider with a track record of success.<br/>
                    <ul className="list mb-0 mt-4">
                      <li>15 years of industry experience</li>
                      <li>900+ projects successfully delivered</li>
                      <li>Using an extensive range of collaboration tool sets</li>
                      <li>On-board field-proven experts within 48 hours</li>
                      <li>Worked with clients from USA, Canada, UK, Australia, India, East Africa, Gulf and many other countries.</li>
                    </ul>
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> How much does it cost to develop a Laravel app? </Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  A Laravel development project would cost between $2,500 and $25,000. There is no definitive answer to this question, thus it depends. The total cost of the Laravel app depends on several parameters, including the functionalities you add, the sort of resources you hire, and the engagement model you select to produce your digital product. To be more exact, Laravel developers will need more time to create the more nuanced features and functionalities you intend to use.<br></br><br></br>
                  If you are outsourcing a Laravel project, the cost of developers is location-dependent. As a result, the cost of building a Laravel application relies on your unique business objectives and the resources you are using in a particular region.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> Which hiring engagement models are available at Moweb? </Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  <p className="fs-md text-secondary mb-2.5">The different hiring engagement options are available from us. You can hire developers from Moweb and choose any model that best suits your companys demands. </p>
                  <p className="fs-md fw-600 text-black mb-2.5">
                  Part-time developer - Hire a part-time Laravel developer and get some hours of support 
                  </p>
                  <ul className="list mb-0 mt-3 mb-2.5">
                      <li>4 hours a day, 5 days a week</li>
                      <li>Minimum - 1 month</li>
                      <li>Billing cycle - Monthly</li>
                      <li>Available as and when required</li>
                    </ul>
                    <p className="fs-md fw-600 text-black mb-2.5">
                    Full-time Developer - Hire our Laravel developer full-time for your custom business requirements
                  </p>
                  <ul className="list mb-0 mt-3 mb-2.5">
                      <li>8 hours a day, 5 days a week</li>
                      <li>Minimum - 1 month</li>
                      <li>Billing cycle - Monthly </li>
                      <li>Works on your projects only</li>
                    </ul>
                    <p className="fs-md fw-600 text-black mb-2.5">
                    Hourly Developer - Hire a Laravel developer on an hourly basis for your custom business needs
                  </p>
                  <ul className="list mb-0 mt-3 mb-2.5">
                      <li>Minimum hours - 25 hours</li>
                      <li>Billing cycle -  Weekly/Monthly</li>
                      <li>Payment as per hours worked </li>
                    </ul>
                    <p className="fs-md text-secondary mb-0">
                    You can let our team know what you need. Our team will assess your needs before providing you with a full estimate of your project, including time and cost estimates as well as a project roadmap. 
                    </p>
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What project management and communication tools do you use for Laravel development?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  We offer a dedicated project management system that enables daily project monitoring, work assignment, and follow-up for your dedicated developers. Our Laravel developers would be reachable by phone, Skype, email, and Chat. Our team is also skilled in using software like JIRA, Basecamp, Teamwork, Slack, etc.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What are the advantages of outsourcing your Laravel website development?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                <div className="fs-md mb-0 text-secondary">
                Some of the primary benefits of outsourcing your Laravel development are listed below: <br/>
                  <ul className="list mb-0 mt-3">
                      <li>Reduce development and maintenance costs</li>
                      <li>Ability to work in your preferred time zone</li>
                      <li>Access to seasoned programmers</li>
                      <li>Development times are shorter.</li>
                      <li>Guaranteed high-quality services</li>
                      <li>Cutting-edge technology</li>
                      <li>Improved knowledge of various platforms</li>
                    </ul>
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
            </Accordion>
        </>
        )
}

export default LaravelFAQ
